import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

import { PasswordFormState, RouteParams } from '../../shared/password-form-state';
import { lazyInject } from '../../ioc';
import { LoginApiService } from 'src/api';

import { ResetPassword } from './desktop/reset-password';
import { RouteComponentProps } from 'react-router';

interface Props extends RouteComponentProps<RouteParams> {
    step: 1 | 2;
}

@observer
export class ResetPasswordContainer extends React.Component<Props> {
    @lazyInject(LoginApiService) private loginApi!: LoginApiService;

    @observable data!: PasswordFormState;

    constructor(props: Props) {
        super(props);
        this.resetForm(props);
    }

    componentWillReceiveProps(nextProps: Readonly<Props>) {
        if (this.props.step !== nextProps.step) {
            this.resetForm(nextProps);
        }
    }

    private resetForm(props: Readonly<Props>) {
        this.data = new PasswordFormState(
            props.step,
            props.match.params.token,
            this.onSubmit,
            '/login/reset/confirm'
        );
    }

    private onSubmit = (token: string, email: string, password: string) =>
        this.loginApi
            .resetPassword({ token, email, password })
            .then((result) => result.data.success);

    render() {
        return <ResetPassword container={this} />;
    }
}
